import { UseMutationResult } from 'react-query';
import { editorService } from '../../../services';
import { useFunctionalUnitTagMutation } from './use-functional-unit-tag-mutation';

export function useFunctionalUnitTagDelete(): UseMutationResult<unknown, unknown, number, unknown> {
    return useFunctionalUnitTagMutation((tagId: number) => editorService.deleteFunctionalUnitTag(tagId));
}
